import React from 'react';
import clsx from 'clsx';
import { Icon, Menu } from 'semantic-ui-react';
import { FormattedMessage, useIntl } from 'react-intl';
import Selectors from '@/layout/hooks/selectors';

const RibbonMenu = ({
  onClick,
  name,
  url,
  target,
  className,
  message,
  titleMessage,
  icon,
  disabled,
  loading,
}) => {
  const intl = useIntl();
  const { hasLabels, fullscreen } = Selectors.useRibbonMenu();

  return (
    <Menu.Item
      name={name}
      title={intl.formatMessage({ id: titleMessage || message })}
      onClick={disabled ? null : onClick}
      href={disabled ? null : url}
      className={clsx('aridhia-ribbon-menu', className)}
      disabled={disabled}
      target={target}
      rel="noopener noreferrer"
    >
      {!fullscreen && !loading && (<Icon name={icon} />)}
      {!fullscreen && loading && (<Icon name="circle notched" loading />)}
      {hasLabels && (<FormattedMessage id={message} />)}
    </Menu.Item>
  );
};

export default RibbonMenu;
